import { render } from "./ScoreCardPlayerRow.vue?vue&type=template&id=f31c5674&scoped=true"
import script from "./ScoreCardPlayerRow.vue?vue&type=script&lang=js"
export * from "./ScoreCardPlayerRow.vue?vue&type=script&lang=js"

import "./ScoreCardPlayerRow.vue?vue&type=style&index=0&id=f31c5674&scoped=true&lang=css"

import exportComponent from "/Users/dgorski/tenball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f31c5674"]])

export default __exports__